import { render, staticRenderFns } from "./DispatchedOrder.vue?vue&type=template&id=68b6f557&scoped=true"
import script from "./DispatchedOrder.vue?vue&type=script&lang=js"
export * from "./DispatchedOrder.vue?vue&type=script&lang=js"
import style0 from "./DispatchedOrder.vue?vue&type=style&index=0&id=68b6f557&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b6f557",
  null
  
)

export default component.exports